import React from 'react'
import { token } from '@planningcenter/tapestry'
import { Box, StackView } from '@planningcenter/tapestry-react'

const Input = (props) => {
  const styles = {
    background: token('--t-form-background-color'),
    border: `1px solid ${token('--t-form-border-color')}`,
    borderRadius: '4px',
    padding: '7px',
    flex: '2',
    fontSize: '14px',
    lineHeight: '16px',
    ':focus': {
      borderColor: token('--t-form-border-color-focus'),
      boxShadow: 'none',
      outlineStyle: 'none',
    },
    '&::placeholder': { color: token('--t-form-placeholder-color') },
  }
  return <Box as="input" {...props} css={styles} />
}

const Label = ({ ...props }) => {
  const styles = {
    color: token('--t-form-color'),
    fontSize: '12px',
    marginBottom: '8px',
    textTransform: 'uppercase',
    flex: '1',
    lineHeight: '16px',
  }
  return <Box as="label" {...props} css={styles} />
}

const Wrapper = ({ ...props }) => {
  const styles = {
    margin: '0 0 16px',
  }
  return <StackView {...props} css={styles} />
}

const TextInput = ({ children, name, ...props }) => {
  return (
    <Wrapper>
      <Label htmlFor={name}>{children || name}</Label>
      <Input {...props} name={name} />
    </Wrapper>
  )
}

export default TextInput
